import { OAuthPopup } from '@tasoskakour/react-use-oauth2';

export default OAuthPopup;
